import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Store, createSelector } from '@ngrx/store';
import { SharedModule } from 'primeng/api';

import { FreyaCommonModule } from '../../freya-common/freya-common.module';
import { JobEstimateComponent } from '../job-estimate/job-estimate.component';
import { JobInvoiceComponent } from '../job-invoice/job-invoice.component';
import {
  selectJob,
  selectJobInCurrentZone,
  selectOtherDocumentsExceptInvoice,
  selectInvoicesSortedByDate,
  selectJobLoaded,
  selectJobLoading
} from '../job-tool.reducer';

import { JobDocumentsActions } from './job-files.actions';

@Component({
  selector: 'app-job-files',
  standalone: true,
  imports: [
    CommonModule,
    FreyaCommonModule,
    SharedModule,
    JobEstimateComponent,
    JobInvoiceComponent,
  ],
  templateUrl: './job-files.component.html',
  styleUrls: [
    './job-files.component.scss',
    '../job-financials/document-container-style.scss',
  ],
})
export class JobFilesComponent {

  viewModel$ = this.store.select(createSelector({
    documents: selectOtherDocumentsExceptInvoice,
    invoices: selectInvoicesSortedByDate,
    documentsEmpty: createSelector(
      selectOtherDocumentsExceptInvoice,
      selectInvoicesSortedByDate,
      selectJobLoaded,
      (documents, invoices, jobLoaded) => jobLoaded && documents.length === 0 && invoices.length === 0,
    ),
    job: selectJob,
    jobLoading: selectJobLoading,
    jobNotInZone: createSelector(selectJobInCurrentZone, (inZone) => !inZone),
  }))

  constructor(
    public store: Store,
  ) {}

  public actions = JobDocumentsActions;

}
